import {Component, Inject, OnInit} from '@angular/core';
import {DXCEligibilityResponse} from '../../../../models/insurance/dxc/patient-eligibility';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {InsuranceService} from '../../../insurance/insurance.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ARService} from '../../ar.service';
import {DXCClaimStatusResponse} from '../../../../models/insurance/dxc/claims';
import {CfgClaimStatusCodeByApiVendor} from '../../models/cfg-claim-status-code-by-api-vendor';

@Component({
  selector: 'app-claim-status-dx-dialog',
  templateUrl: './claim-status-dx-dialog.component.html',
  styleUrls: ['./claim-status-dx-dialog.component.scss']
})
export class ClaimStatusDxDialogComponent implements OnInit{
  isLoading: boolean = true;
  ARClaimID: string;
  x12ClaimStatusCodeGroupsOriginal: CfgClaimStatusCodeByApiVendor[] = [];
  x12ClaimStatusCodeGroups: CfgClaimStatusCodeByApiVendor[] = [];
  x12ClaimStatusCodeGroupsStatusCode: CfgClaimStatusCodeByApiVendor[] = [];
  x12ClaimStatusCodeGroupsEntityCode: CfgClaimStatusCodeByApiVendor[] = [];
  enumClaimMessageCodeGroupStatusCode: string = '00000544-1000-0000-0000-000000000010';

  dxClaimStatusResponse: DXCClaimStatusResponse;
  jsonResp: DXCEligibilityResponse;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private arService: ARService,
    private insuranceService: InsuranceService,
    private snackBar: MatSnackBar,
    private dialogRef: MatDialogRef<ClaimStatusDxDialogComponent>
  ) { }

  ngOnInit(): void {

    if (this.data != null) {
      this.ARClaimID = this.data.ARClaimID;
      this.loadClaimStatus();
      this.loadClaimStatusCodes();
    }
  }

  private loadClaimStatusCodes() {
    this.insuranceService.getX12ClaimStatusCodes()
      .subscribe(response => {
        this.x12ClaimStatusCodeGroupsOriginal = response;
        this.x12ClaimStatusCodeGroups = this.x12ClaimStatusCodeGroupsOriginal.filter(a => a.enumClaimMessageCodeGroupID !== this.enumClaimMessageCodeGroupStatusCode);
        this.x12ClaimStatusCodeGroupsStatusCode = this.x12ClaimStatusCodeGroupsOriginal.filter(a => a.enumClaimMessageCodeGroupID === this.enumClaimMessageCodeGroupStatusCode);
      }, err => {
        this.showMessage('Error', 'Error getting claim status codes');
      });
  }

  private loadClaimStatus() {
    this.insuranceService.getDXClaimStatusResult(this.ARClaimID)
      .subscribe(response => {
        this.dxClaimStatusResponse = response;
        this.jsonResp = response;
        this.isLoading = false;

      }, err => {
        this.showMessage('Error', 'Error getting claim status response');
      });
  }

  showMessage(type, message) {
    this.snackBar.open(message, type, {
      duration: 3000,
      verticalPosition: 'top'
    });
  }

  closeWindow() {
    this.dialogRef.close();
  }

  returnCodeText(code: string, codeType: number): string {
    let returnCode: string = '';
    if (codeType === 1) {
      this.x12ClaimStatusCodeGroups.forEach(a => {
        if (a.Code === code) {
          returnCode = a.Description;
        }
      });
    }
    else if (codeType === 2) {
      this.x12ClaimStatusCodeGroupsStatusCode.forEach(a => {
        if (a.Code === code) {
          returnCode = a.Description;
        }
      });
    }
    else if (codeType === 3) {
      this.x12ClaimStatusCodeGroupsEntityCode.forEach(a => {
        if (a.Code === code) {
          returnCode = a.Description;
        }
      });
    }
    return returnCode;
  }
}
